// Vendor
import $ from 'jquery';

// Elements
let $el = $('.tab-component');

class Tabs {
	constructor(el) {
		// Active Tab
		this.activeTabIndex = 0;

		// Elements
		this.$el = $(el);
		this.$tabButtons = this.$el.find('.tab-buttons button');
		this.$tabsWindowWrapper = this.$el.find('.tab-windows');
		this.$tabWindows = this.$tabsWindowWrapper.children();

		// Expand animations
		this.tabsExpand = this.$el.data('expand')
			? this.$el.data('expand')
			: false;

		// Classes
		this.activeClass = 'is-active';

		// Tab window transition duration (ms)
		this.transitionDuration = 500;

		// Timeout ref
		this.tabSwitchTimeout;

		// Dropdown logic
		this.hasMobileDropdown =
			this.$el.hasClass('has-mobile-dropdown') ||
			this.$el.hasClass('has-tablet-dropdown')
				? true
				: false;

		if (this.hasMobileDropdown) {
			this.setupMobileDropdown();
		}

		this.setupTabs();
		this.attachEvents();

		this.handleHashChange();

		//if query string exist set the relative tab
		if (this.getParameterByName('pass-reset-token')) {
			this.activeTabIndex = 2;
			this.setupTabs();
			this.switchTabs();
		}
	}

	slugifyString(text) {
		return (
			text
				.toString()
				.toLowerCase()
				.trim()
				.replace(/\s+/g, '-') // Replace spaces with -
				// .replace(/[^\w\-]+/g, '') // Remove all non-word chars
				.replace(/--+/g, '-') // Replace multiple - with single -
				.replace(/-and-/g, '-') // remove 'and'
				.replace(/-&-/g, '-')
		); // remove '&'
	}

	setupTabs() {
		// Add a slug attribute to all tabs
		this.$tabButtons.each((index, item) => {
			item.setAttribute('data-slug', this.slugifyString(item.innerText));
		});

		// find tallest tab
		this.$tallestTab = $(
			Array.from(this.$tabWindows).reduce(
				(prev, current) => {
					return current.clientHeight > prev.clientHeight
						? current
						: prev;
				},
				{ clientHeight: 0 }
			)
		);

		if (!this.tabsExpand) {
			//tabs should not expand, use tallest tab as height
			this.$tallestTab.css({
				position: 'relative'
			});
		} else {
			//tabs to expand, add expanding class
			this.$el.addClass('expanding');
		}

		//apply transition duration css
		this.$tabWindows.css({
			transitionDuration: this.transitionDuration / 1000 + 's'
		});
		this.$tabsWindowWrapper.css({
			transitionDuration: this.transitionDuration / 1000 + 's'
		});
		//tab button Widths
		this.$tabButtons.css({
			width: 100 / this.$tabButtons.length + '%'
		});
		//initial tab state
		this.$tabButtons.eq(this.activeTabIndex).addClass(this.activeClass);
		this.$tabWindows.eq(this.activeTabIndex).addClass(this.activeClass);
	}

	setupMobileDropdown() {
		let $buttons = $.makeArray(this.$tabButtons);
		if ($buttons.length) {
			let $mobileDropdown = $(`
				<div class="tab-mobile-dropdown mobile-dropdown">
					<select>
						${$buttons
		.map(v =>
			`
							<option value="${this.slugifyString(
		$(v)
			.find('span')
			.text()
	)}">
								${$(v)
		.find('span')
		.text()}
							</option>
						`.trim()
		)
		.join('')}
					</select>
				</div>
			`);
			$mobileDropdown.insertBefore(this.$tabsWindowWrapper);
			this.$mobileDropdown = $mobileDropdown.find('select');
		}
	}

	handleHashChange() {
		const hash = window.location.hash.substr(1);
		if (!hash) {
			return;
		}
		const activeTab = document.querySelector(`button[data-slug="${hash}"]`);
		const activeTabIndex = $(activeTab).index();
		this.previousTabIndex = this.activeTabIndex;
		this.activeTabIndex = activeTabIndex;
		this.switchTabs();
	}

	attachEvents() {
		window.addEventListener('hashchange', this.handleHashChange.bind(this));

		this.$tabButtons.on('click', evt => {
			const tabSlug = $(evt.currentTarget).attr('data-slug');
			if (tabSlug) {
				window.location.hash = tabSlug;
			}
		});

		if (this.hasMobileDropdown && this.$tabButtons.length) {
			this.$mobileDropdown.on('change', evt => {
				clearTimeout(this.tabSwitchTimeout);
				const tabSlug = evt.target.value;
				if (tabSlug) {
					window.location.hash = tabSlug;
				}
			});
		}
	}

	switchTabs() {
		let previousTabWindow = this.$tabWindows.eq(this.previousTabIndex);
		let activeTabButton = this.$tabButtons.eq(this.activeTabIndex);
		let activeTabWindow = this.$tabWindows.eq(this.activeTabIndex);

		//switch tab button Classes
		this.$tabButtons.removeClass(this.activeClass);
		activeTabButton.addClass(this.activeClass);

		//fade out old window
		this.$tabWindows.removeClass(this.activeClass);

		//set wrapper height based off previously active tab
		if (this.tabsExpand) {
			this.$tabsWindowWrapper.css({
				height: previousTabWindow.outerHeight()
			});
		}

		// If tab has mobile dropdown, set correct value
		if (this.hasMobileDropdown) {
			this.$mobileDropdown[0].selectedIndex = this.activeTabIndex;
		}

		//delay fade in/new active window class
		this.tabSwitchTimeout = setTimeout(
			() => {
				//adjust window height to new tab
				if (this.tabsExpand) {
					this.$tabsWindowWrapper.css({
						height: activeTabWindow.outerHeight()
					});
				}

				this.tabSwitchTimeout = setTimeout(() => {
					//add active class to new tab
					activeTabWindow.addClass(this.activeClass);
					// //reset height
					if (this.tabsExpand) {
						this.$tabsWindowWrapper.css({
							height: 'auto'
						});
					}
				}, this.transitionDuration);
			},
			this.tabsExpand ? this.transitionDuration : 0
		);
	}

	getParameterByName(name, url) {
		if (!url) {
			url = window.location.href;
		}

		if (url.indexOf('?' + name + '=') !== -1) {
			return true;
		} else if (url.indexOf('&' + name + '=') !== -1) {
			return true;
		}
		return false;
	}
}

export default Tabs;

const _init = () => {
	if ($el.length) {
		//TODO iterate and init on each found element?
		new Tabs($el);
	}
};

_init();
